import { Trans, useLingui } from '@lingui/react/macro';

export function FolderDefaultPriorityHint() {
  return (
    <p className='text-xs text-muted-fg'>
      <Trans>
        Sets the default priority for documents added to this folder from now
        on. Existing documents in this folder keep their current priority.
      </Trans>
    </p>
  );
}

export function useFolderDefaultPriorityTooltip() {
  const { t } = useLingui();

  return t`Default priority for new documents in this folder. Existing documents are not changed.`;
}

export function useKnowledgePriorityHeaderTooltip() {
  const { t } = useLingui();

  return t`When the agent retrieves knowledge to answer a question, higher priority gives this source a stronger boost in ranking. Lower-priority sources can still be used if they match the question better.`;
}
